import { useSelector } from 'react-redux';

import type { RootReduxState } from '../../utils/types';
import { useFeatures } from '@paralleldrive/react-feature-toggles';

import CreateNewShop, { SelectedShopCookie } from './CreateNewShop';

const OnBoarding = ({
  withShopCookie = true,
}: {
  withShopCookie?: boolean;
}) => {
  const features = useFeatures();
  const isFetching = useSelector<RootReduxState, boolean>((state) =>
    Boolean(state.getIn(['global', 'featureToggles', 'UIStates', 'fetching'])),
  );

  if (isFetching || features.includes('onboardingQuestionnaire')) return null;

  /**
   * To prevent getting incorrect values from features array (become empty when fetching)
   * do not render component while fetching feature toggles
   */
  return (
    <>
      {withShopCookie ? <SelectedShopCookie /> : null}
      <CreateNewShop />
    </>
  );
};

export { OnBoarding };
